<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <common-docs-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></common-docs-form>
  </j-modal>
</template>

<script>

  import CommonDocsForm from './CommonDocsForm'
  export default {
    name: 'CommonDocsModal',
    components: {
      CommonDocsForm
    },
    data () {
      return {
        title: '',
        width: 896,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (docType) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add(docType);
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>